import { render, staticRenderFns } from "./physicalFitness.vue?vue&type=template&id=94526596&scoped=true&"
import script from "./physicalFitness.vue?vue&type=script&lang=js&"
export * from "./physicalFitness.vue?vue&type=script&lang=js&"
import style0 from "./physicalFitness.vue?vue&type=style&index=0&id=94526596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94526596",
  null
  
)

export default component.exports